import { useEffect, useState } from 'react'

import { randomIntFromInterval } from '~/bootcamp/Activities/utils/activities.utils'

interface Slice {
  isColored: boolean
}

interface Props {
  isSelected?: boolean
  isWrong?: boolean
  numerator: number
  denominator: number
  onToggleColor?: (data: Slice[]) => void | undefined
  className?: string
  isRandomFill?: boolean
  onClick?: () => void
}

export function RectangleWithSlice({
  isSelected = false,
  isWrong,
  numerator = 0,
  denominator = 2,
  onToggleColor = undefined,
  className = '',
  isRandomFill = false,
  ...rest
}: Props): React.ReactElement {
  const [slices, setSlices] = useState<Slice[]>([])

  useEffect(() => {
    const colored: boolean[] = []
    const history: number[] = []

    if (isRandomFill) {
      new Array(numerator).fill(null).forEach(() => {
        const randomIndex = randomIntFromInterval(0, denominator - 1, history)
        history[history.length] = randomIndex
        colored[randomIndex] = true
      })
    } else {
      const colorStartPosition = randomIntFromInterval(0, denominator - numerator)
      new Array(numerator).fill(null).forEach((item, index) => {
        colored[index + colorStartPosition] = true
      })
    }

    const _slices = new Array(denominator).fill(null).map((item, index) => ({
      isColored: !!colored[index],
    }))
    setSlices(_slices)
  }, [denominator, numerator, isRandomFill])

  const onToggleColors = (index: number): void => {
    if (onToggleColor) {
      setSlices((prevState) => {
        const newState = [...prevState]
        newState[index] = {
          isColored: !newState[index].isColored,
        }
        onToggleColor(newState)
        return newState
      })
    }
  }

  return (
    <div
      className={`${className} ${isWrong ? 'border-2 border-red-wrong-choice ' : ''}${
        isSelected ? 'border-2 border-purple' : ''
      }`}
      {...rest}
    >
      {slices.map((slice, index) => (
        <div
          className={` h-7 border-2 border-black ${index + 1 === denominator ? 'border-b-2 ' : 'border-b-0 '} ${
            slice.isColored && 'bg-purple '
          } ${onToggleColor && 'cursor-pointer'}`}
          key={slice.isColored.toString() + index.toString()}
          onClick={() => {
            onToggleColors(index)
          }}
        />
      ))}
    </div>
  )
}
